export default "__VITE_ASSET__DMg_3FEo__"